import { FaMousePointer, FaCircle, FaHeading, FaRegFileAlt, FaExternalLinkAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { GridItem } from '@chakra-ui/react'
import { SettingsCard } from '../../../components/SettingsCard'
import './grid-edicao-cms.scss'
import { useState, useEffect } from 'react'

const GridEdicaoCMS = () => {
  const navigate = useNavigate()
  const [submenus, setSubmenus] = useState<any[]>([])

  useEffect(() => {
    const permissaoAcessos = localStorage.getItem('permissaoAcesso')
    if (permissaoAcessos) {
      const parsedPermissaoAcesso = JSON.parse(permissaoAcessos)

      const edicaoSubmenus = parsedPermissaoAcesso
        .filter((item: any) => item.menuDTO.fkCodMenu === 30000)
        .map((item: any) => {
          let path = `/cms/edicao-cidade-inteligente/${item.menuDTO.dscMenu.toLowerCase().replace(/\s+/g, '-')}`;
          let icon;

          switch(item.menuDTO.codMenu) {
            case 31000:
              icon = FaHeading;
              path = 'editar-cabecalho';
              break;
            case 32000:
              icon = FaMousePointer;
              path = 'faixa-navegacao-principal';
              break;
            case 33000:
              icon = FaRegFileAlt;
              path = 'rodape';
              break;
            case 34000:
              icon = FaExternalLinkAlt;
              path = 'outras-paginas';
              break;
            default:
              icon = FaCircle;
          }

          return {
            cardTitle: item.menuDTO.dscMenu,
            path: path,
            icon: icon
          }
        })

      setSubmenus(edicaoSubmenus)
    }
  }, [])

  return (
    <div className='main-container-grid'>
      {submenus.map((submenu, index) => (
        <GridItem key={index}>
          <SettingsCard
            buttonText="Acessar"
            onClick={() => navigate(submenu.path)}
            icon={submenu.icon}
            cardTitle={submenu.cardTitle}
          />
        </GridItem>
      ))}
    </div>
  )
}

export default GridEdicaoCMS
